import { GetInterfacePagesInput } from "@zapier/bff";
import { RouterOutputs, trpc } from "../trpc";

interface UseInterfacePagesOptions {
  enabled?: boolean;
}

export type InterfacePage =
  RouterOutputs["interface"]["getPages"]["results"][number];

export function useInterfacePages(
  input: GetInterfacePagesInput,
  options?: UseInterfacePagesOptions,
) {
  const { data, isLoading, isFetching } = trpc.interface.getPages.useQuery(
    input,
    { enabled: Boolean(input.id) && options?.enabled !== false },
  );

  return {
    pages: data?.results,
    isLoading,
    isFetching,
  };
}
